import { ReactNode } from 'react';
import { AppLogo } from '../branding/AppLogo';

interface AuthPageHeaderProps {
  title?: string;
  subtitle?: ReactNode;
}

export function AuthPageHeader({ title, subtitle }: AuthPageHeaderProps) {
  return (
    <div className="mb-8 text-center">
      <AppLogo className="mx-auto h-20 w-auto max-w-full object-contain" />
      {title ? (
        <h1 className="mt-4 text-xl font-bold text-secondary-900">{title}</h1>
      ) : null}
      {subtitle ? (
        <div className={title ? 'mt-2 text-sm text-secondary-500' : 'mt-4 text-sm text-secondary-500'}>
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}
